module.exports = {
    cognitoUserPoolClientId: '7egrqsm6rit248udkgi1ro0jds',
    cognitoUserPoolId: 'us-east-1_Du8hO846w',
    environment: 'dev-lower',
    lowerEnvironment: '',
    restApiEndpoint: 'https://vp8tx8ept8.execute-api.us-east-1.amazonaws.com/dev-lower',
    restApiName: 'dev-lower-dsco-ship-codes-ApiStack-1Y0W6YIZR1TJX'
}
